import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Freight Cost (RatesScreen.tsx). Mã hãng, mã cảng, loại cont và dữ liệu mẫu không dịch.
addMessages('vi', {
  'rt.stOk': 'Còn hạn',
  'rt.stSoon': 'Sắp hết ≤ 7 ngày',
  'rt.stExp': 'Hết hạn',
  'rt.stNone': 'Chưa có giá',
  'rt.none': 'Chưa có',
  'rt.buyLbl': 'Giá mua',
  'rt.viaP': 'qua {v}',
  'rt.direct': 'Trực tiếp',
  'rt.cheapUsd': 'USD / cont · rẻ nhất trước',
  'rt.byTT': 'xếp theo T/T',
  'rt.podSheet': 'Chọn tuyến & hãng',
  'rt.dayN': '{n} ngày',
  'rt.dayNeg': '−{n} ngày',
  'rt.allCarriers': 'Mọi hãng',
  'rt.statusAria': 'Tình trạng tuyến giá',
  'rt.hilite': 'Làm nổi các ô {s}',
  'rt.gridAria': 'Lưới hãng và tuyến',
  'rt.gridTitle': 'Hãng × Tuyến',
  'rt.lanesN': '{n} tuyến',
  'rt.carriersN': '{n} hãng',
  'rt.groupAria': 'Nhóm tuyến',
  'rt.all': 'Tất cả',
  'rt.top8': 'Top 8 hãng theo số job 12 tháng',
  'rt.main': 'Hãng chủ lực',
  'rt.statusTable': 'Tình trạng giá theo hãng và tuyến',
  'rt.lane': 'Tuyến',
  'rt.covered': '{c}/{s} hãng có giá còn hạn',
  'rt.noServe': '{c} · {r} · hãng không chạy tuyến',
  'rt.hLane': 'Tuyến · transit',
  'rt.hCarrier': 'Hãng',
  'rt.hValid': 'Hiệu lực',
  'rt.hFree': 'Free DEM/DET',
  'rt.hSrc': 'Nguồn',
  'rt.hQuote': 'BG · Job',
  'rt.tableAria': 'Bảng giá cước',
  'rt.maskAria': 'Giá mua bị che theo quyền',
  'rt.expiredAgo': 'hết hạn {n} ngày',
  'rt.leftN': 'còn {n} ngày',
  'rt.demdet': '{a} / {b} ngày',
  'rt.useTitle': '{q} báo giá Live · {j} job đang dùng dòng giá này',
  'rt.foot': 'USD / cont · giá mua của hãng · {n} dòng',
  'rt.up': '▲ tăng',
  'rt.down': '▼ giảm',
  'rt.flat': '– giữ',
  'rt.quick': 'Tra cứu nhanh',
  'rt.pol': 'Cảng đi',
  'rt.pod': 'Cảng đến',
  'rt.contAria': 'Loại cont',
  'rt.buyHidden': 'Giá mua ẩn.',
  'rt.hasRate': '{n} hãng có giá',
  'rt.cheap': 'rẻ → đắt',
  'rt.byCarrier': 'theo hãng',
  'rt.validTitle': 'Hiệu lực {d}/2026',
  'rt.route': 'Đường đi {v}',
  'rt.tt': 'T/T {n} ngày',
  'rt.vsPrev': 'So kỳ trước',
  'rt.noLane': 'Chưa có giá trên tuyến',
  'rt.askTitle': 'Hỏi giá đối tác — làm ở C-05',
  'rt.askBtn': 'Hỏi hãng',
  'rt.buyUsd': 'Giá mua · USD / cont',
  'rt.secValid': 'Hiệu lực',
  'rt.until': 'Đến ngày',
  'rt.secRoute': 'Tuyến & dịch vụ',
  'rt.via': 'Đường đi',
  'rt.secUse': 'Sử dụng',
  'rt.liveQuote': 'Báo giá Live',
  'rt.jobsUse': 'Job đang dùng',
  'rt.tAn': 'Phân tích',
  'rt.tSur': 'Phụ phí',
  'rt.tSync': 'Đồng bộ giá',
  'rt.building': 'Đang dựng.',
  'rt.searchPh': 'Tìm tuyến, hãng, nguồn',
  'rt.showExpired': 'Hiện cả giá hết hạn',
  'rt.expiredChip': 'Giá hết hạn',
  'rt.clear': 'Xoá lọc',
  'rt.masked': 'Giá mua bị che theo quyền.',
  'rt.noMatch': 'Không có dòng giá khớp',
  'rt.noMatchD': 'Bỏ bớt bộ lọc hoặc bật Giá hết hạn.',
  'rt.sub': 'Giá mua của hãng',
  'rt.section': 'Mục',
  'rt.tDesk': 'Bàn Pricing',
  'rt.tList': 'Danh sách',
  'rt.tLookup': 'Tra cứu',
  'rt.tQueue': 'Hàng việc',
  'rt.lookupTitle': 'Tra cứu giá mua',
  'rt.filter': 'Lọc',
  'rt.qTool': 'Hàng việc Pricing',
  'rt.noti': 'Thông báo',
  'rt.more': 'Thao tác khác',
  'rt.noWrite': 'Chưa bật ghi Freight Cost',
  'rt.addRate': 'Nhập giá',
  'rt.openP2P': 'Mở Giá và Lịch',
  'rt.inqPartner': 'Hỏi giá đối tác',
  'rt.emptyT': 'Chưa có dòng giá',
  'rt.nopermT': 'Chỉ Pricing xem Freight Cost',
  'rt.errT': 'Không tải được bảng giá',
  'rt.nopermD': 'Xin quyền Pricing ở Cài đặt.',
  'rt.errD': 'Mất kết nối tới máy chủ. Dữ liệu đang hiện là bản đã lưu.',
  'rt.retry': 'Thử lại',
});
addMessages('en', {
  'rt.stOk': 'Valid',
  'rt.stSoon': 'Expiring ≤ 7 days',
  'rt.stExp': 'Expired',
  'rt.stNone': 'No rate',
  'rt.none': 'None',
  'rt.buyLbl': 'Buy rate',
  'rt.viaP': 'via {v}',
  'rt.direct': 'Direct',
  'rt.cheapUsd': 'USD / cont · cheapest first',
  'rt.byTT': 'sorted by T/T',
  'rt.podSheet': 'Choose lane & carrier',
  'rt.dayN': '{n} days',
  'rt.dayNeg': '−{n} days',
  'rt.allCarriers': 'All carriers',
  'rt.statusAria': 'Lane rate status',
  'rt.hilite': 'Highlight {s} cells',
  'rt.gridAria': 'Carrier × lane grid',
  'rt.gridTitle': 'Carrier × Lane',
  'rt.lanesN': '{n} lanes',
  'rt.carriersN': '{n} carriers',
  'rt.groupAria': 'Lane group',
  'rt.all': 'All',
  'rt.top8': 'Top 8 carriers by jobs in 12 months',
  'rt.main': 'Key carriers',
  'rt.statusTable': 'Rate status by carrier and lane',
  'rt.lane': 'Lane',
  'rt.covered': '{c}/{s} carriers with valid rates',
  'rt.noServe': '{c} · {r} · carrier does not serve this lane',
  'rt.hLane': 'Lane · transit',
  'rt.hCarrier': 'Carrier',
  'rt.hValid': 'Validity',
  'rt.hFree': 'Free DEM/DET',
  'rt.hSrc': 'Source',
  'rt.hQuote': 'Quotes · Jobs',
  'rt.tableAria': 'Rate table',
  'rt.maskAria': 'Buy rate hidden by permission',
  'rt.expiredAgo': 'expired {n} days ago',
  'rt.leftN': '{n} days left',
  'rt.demdet': '{a} / {b} days',
  'rt.useTitle': '{q} live quotes · {j} jobs using this rate',
  'rt.foot': 'USD / cont · carrier buy rate · {n} rows',
  'rt.up': '▲ up',
  'rt.down': '▼ down',
  'rt.flat': '– flat',
  'rt.quick': 'Quick lookup',
  'rt.pol': 'Port of loading',
  'rt.pod': 'Port of discharge',
  'rt.contAria': 'Container type',
  'rt.buyHidden': 'Buy rate hidden.',
  'rt.hasRate': '{n} carriers with rates',
  'rt.cheap': 'low → high',
  'rt.byCarrier': 'by carrier',
  'rt.validTitle': 'Valid until {d}/2026',
  'rt.route': 'Route {v}',
  'rt.tt': 'T/T {n} days',
  'rt.vsPrev': 'Vs previous period',
  'rt.noLane': 'No rate on this lane',
  'rt.askTitle': 'Ask partner for rates — in C-05',
  'rt.askBtn': 'Ask carrier',
  'rt.buyUsd': 'Buy rate · USD / cont',
  'rt.secValid': 'Validity',
  'rt.until': 'Until',
  'rt.secRoute': 'Lane & service',
  'rt.via': 'Route',
  'rt.secUse': 'Usage',
  'rt.liveQuote': 'Live quotes',
  'rt.jobsUse': 'Jobs in use',
  'rt.tAn': 'Analysis',
  'rt.tSur': 'Surcharges',
  'rt.tSync': 'Rate sync',
  'rt.building': 'Under construction.',
  'rt.searchPh': 'Search lane, carrier, source',
  'rt.showExpired': 'Show expired rates too',
  'rt.expiredChip': 'Expired rates',
  'rt.clear': 'Clear filters',
  'rt.masked': 'Buy rates hidden by permission.',
  'rt.noMatch': 'No matching rates',
  'rt.noMatchD': 'Remove filters or turn on Expired rates.',
  'rt.sub': 'Carrier buy rates',
  'rt.section': 'Section',
  'rt.tDesk': 'Pricing desk',
  'rt.tList': 'List',
  'rt.tLookup': 'Lookup',
  'rt.tQueue': 'Queue',
  'rt.lookupTitle': 'Buy-rate lookup',
  'rt.filter': 'Filter',
  'rt.qTool': 'Pricing queue',
  'rt.noti': 'Notifications',
  'rt.more': 'More actions',
  'rt.noWrite': 'Freight Cost writing is not enabled',
  'rt.addRate': 'Add rate',
  'rt.openP2P': 'Open Rates & Schedules',
  'rt.inqPartner': 'Partner inquiries',
  'rt.emptyT': 'No rates yet',
  'rt.nopermT': 'Only Pricing can view Freight Cost',
  'rt.errT': 'Could not load the rate table',
  'rt.nopermD': 'Request Pricing access in Settings.',
  'rt.errD': 'Lost connection to the server. Showing saved data.',
  'rt.retry': 'Retry',
});
